var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg003Transform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_003-transform",
    "data-name": "003-transform",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80167",
    "data-name": "Path 80167",
    d: "M19.6,14.8A4.8,4.8,0,1,1,14.8,10,4.8,4.8,0,0,1,19.6,14.8Z",
    transform: "translate(11.2 11.2)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80168",
    "data-name": "Path 80168",
    d: "M27.451,20.4a7.085,7.085,0,0,1,.432-2.366l-.017.05A2.2,2.2,0,0,0,27.46,18H8.251a2.161,2.161,0,0,0-.43.089l.014,0A6.517,6.517,0,0,1,8.251,20.4a6.642,6.642,0,0,1-.43,2.362l.014-.046a2.2,2.2,0,0,0,.406.084h19.21a2.161,2.161,0,0,0,.43-.089l-.014,0a6.965,6.965,0,0,1-.415-2.311Z",
    transform: "translate(8.149 22.4)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80169",
    "data-name": "Path 80169",
    d: "M30.4,23.2A7.2,7.2,0,1,1,23.2,16,7.2,7.2,0,0,1,30.4,23.2Z",
    transform: "translate(17.6 17.6)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80170",
    "data-name": "Path 80170",
    d: "M30.4,9.2A7.2,7.2,0,1,1,23.2,2,7.2,7.2,0,0,1,30.4,9.2Z",
    transform: "translate(17.6 -2)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80171",
    "data-name": "Path 80171",
    d: "M16.4,23.2A7.2,7.2,0,1,1,9.2,16,7.2,7.2,0,0,1,16.4,23.2Z",
    transform: "translate(-2 17.6)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80172",
    "data-name": "Path 80172",
    d: "M16.4,9.2A7.2,7.2,0,1,1,9.2,2,7.2,7.2,0,0,1,16.4,9.2Z",
    transform: "translate(-2 -2)",
    fill: "#12784a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_80173",
    "data-name": "Path 80173",
    d: "M6.4,27.452a7.085,7.085,0,0,1,2.366.432l-.05-.017a2.2,2.2,0,0,0,.084-.406V8.252a2.161,2.161,0,0,0-.089-.43l0,.014A6.965,6.965,0,0,1,6.4,8.252h0A7.086,7.086,0,0,1,4.034,7.82l.05.017A2.2,2.2,0,0,0,4,8.242v19.21a2.162,2.162,0,0,0,.089.43l0-.014A6.965,6.965,0,0,1,6.4,27.452Z",
    transform: "translate(2.8 8.148)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80174",
    "data-name": "Path 80174",
    d: "M8.252,6.4A7.086,7.086,0,0,1,7.82,8.766l.017-.05a2.2,2.2,0,0,0,.406.084h19.21a2.161,2.161,0,0,0,.43-.089l-.014,0A6.965,6.965,0,0,1,27.452,6.4v0a7.085,7.085,0,0,1,.432-2.366l-.017.05A2.2,2.2,0,0,0,27.462,4H8.252a2.161,2.161,0,0,0-.43.089l.014,0A6.965,6.965,0,0,1,8.252,6.4Z",
    transform: "translate(8.148 2.8)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80175",
    "data-name": "Path 80175",
    d: "M20.4,27.451a7.085,7.085,0,0,1,2.366.432l-.05-.017a2.2,2.2,0,0,0,.084-.406V8.251a2.161,2.161,0,0,0-.089-.43l0,.014a6.517,6.517,0,0,1-2.316.415,6.641,6.641,0,0,1-2.362-.43l.046.014A2.2,2.2,0,0,0,18,8.241v19.21a2.161,2.161,0,0,0,.089.43l0-.014a6.965,6.965,0,0,1,2.311-.415Z",
    transform: "translate(22.4 8.149)",
    fill: "#02fdb1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Transform);
export default __webpack_public_path__ + "static/media/003-transform.356a329068eb7c1de7c06b7a4f3a154c.svg";
export { ForwardRef as ReactComponent };